import { IModuleParams } from "~/types";
import servicesInstall from "./services";

export default async (params: IModuleParams | void) => {
  await servicesInstall(params);
};
